// extracted by mini-css-extract-plugin
module.exports = {"main":"preview_main__25I9l","img":"preview_img__3RY78"};